<div class="body">
  <div class="container">
    <div class="row title-box mt-3">
      <div class="col-12 col-sm-12">
        <h3 class="txtbienvenida">Consultar <span class="txtbienvenida-2">cuentas de cobro</span>
      </h3>
    </div>
  </div>
  <div class="hr bg-green">Datos </div>
  <form [formGroup]="filtrosForm">
    <div class="row">
      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
        <div class="mb-3">
          <label for="" class="form-label">Número de cuenta</label>
          <input type="text" maxlength="15" class="form-control" formControlName="numeroCuenta">
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
        <div class="mb-3">
          <label for="" class="form-label">Estado</label>
          <select class="form-control selectpicker" data-size="5" title="Seleccione una opción" data-live-search="true" formControlName="estado">
            <option value="ENVIADA">ENVIADA</option>
            <option value="PAGADA">PAGADA</option>
            <option value="ANULADA">ANULADA</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row myForm">
      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
          <div class="mb-3" [ngClass]="{
              err: isValidFieldConsultaOperacionesForm('fechaInicial')
            }">
          <label class="form-label">Fecha inicial de creación cuenta de cobro</label>
            <input type="date" class="form-control" [ngClass]="{
                'is-invalid':
                  isValidFieldConsultaOperacionesForm('fechaInicial')
              }" formControlName="fechaInicial" (change)="validarFechas()" min="1950-01-01" max="{{fechaActual}}" />
            <div class="invalid-feedback">
              La fecha incial no puede ser menor a la fecha final.
            </div>
          </div>

        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
          <div class="mb-3" [ngClass]="{
              err: isValidFieldConsultaOperacionesForm('fechaFinal')
            }">
            <label class="form-label">Fecha final de creación cuenta de cobro</label>
            <input type="date" class="form-control" [ngClass]="{
                'is-invalid': isValidFieldConsultaOperacionesForm('fechaFinal')
              }" formControlName="fechaFinal" (change)="validarFechas()" min="obtenerValorCampo('fechaInicial')" max="{{fechaActual}}"/>
            </div>
          </div>
        </div>
        <div class="row justify-content-md-center">
          <div class="col-12 col-md-2 container-btn">
            <button class="btn btn-primary hvr-shrink" style="width: 180px;" type="submit"
            (click)="filtrarCuentas()">Consultar</button>
          </div>
          <div class="col-12 col-md-2 container-btn">
            <button class="btn btn-primary hvr-shrink" style="width: 180px;" type="button"
            (click)="clear()">Limpiar Filtro</button>
          </div>
          <div class="col-12 col-md-2 container-btn">
            <button class="btn  btn-primary hvr-shrink" style="width: 180px;"
            routerLink="/intermediario/home">Volver</button>
          </div>
        </div>
        <div class="row justify-content-md-center">
          <div class="col-12 col-md-3 container-btn">
            <button class="btn btn-primary hvr-shrink" style="width: 180px;" type="button"
            (click)="exportar(true)">Exportar a Excel</button>
          </div>
          <div class="col-12 col-md-3 container-btn">
            <button class="btn btn-primary hvr-shrink" style="width: 180px;" type="button"
            (click)="exportar(false)">Exportar a Txt</button>
          </div>
        </div>
      </form>
      @if (listaCuentas.length > 0) {
        <div class="row mt-4 pr-3 pl-3">
          <div class="table-responsive">
            <table class="table table-striped table-borderless rounded">
              <thead class="table_head">
                <tr>
                  <th scope="col" class="no-styles table-header">
                    Número de cuenta de cobro
                  </th>
                  <th scope="col" class="no-styles table-header">
                    Aliado
                  </th>
                  <th scope="col" class="no-styles table-header">
                    Identificación del Aliado
                  </th>
                  <th scope="col" class="no-styles table-header">
                    Valor total
                  </th>
                  <th scope="col" class="no-styles table-header">
                    Estado
                  </th>
                  <th scope="col" class="no-styles table-header">
                    Fecha de generación
                  </th>
                  <th scope="col" class="no-styles table-header">
                    Fecha de pago
                  </th>
                  <th scope="col" class="no-styles table-header">Acciones</th>
                </tr>
              </thead>
              <tbody>
                @for (cuenta  of listaCuentas; track cuenta ; let i = $index) {
                  <tr>
                    <td>{{cuenta.numeroCuentaCobro}}</td>
                    <td>{{cuenta.nombreCliente | uppercase}}</td>
                    <td>{{cuenta.nitCliente}}</td>
                    <td>{{cuenta.total | currency:'USD' : 'symbol' : '1.0-0'}}</td>
                    <td>{{cuenta.estado }}</td>
                    <td>{{cuenta.fechaCreacion | date: 'dd/MM/yyyy' : 'UTC'}}</td>
                    <td>{{cuenta.fechaPago === null ? 'N.A' : cuenta.fechaPago | date: 'dd/MM/yyyy' : 'UTC'}}</td>
                    <td>
                      <div class="row justify-content-center">
                        <a (click)="ver(i, cuenta.estado)"
                          ><i class="fas fa-eye text-light"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
      <app-pagination (event)="selectPage($event)"
      [paginaActual]="paginaActual" [totalPaginas]="totalPaginas"></app-pagination>
    </div>
    <a id="downloadFile" style="display: none"></a>
    <div class="footer-body"></div>
  </div>
  <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
